import { render, staticRenderFns } from "./UResetPassComp.vue?vue&type=template&id=703e9636&scoped=true&"
import script from "./UResetPassComp.vue?vue&type=script&lang=ts&"
export * from "./UResetPassComp.vue?vue&type=script&lang=ts&"
import style0 from "./UResetPassComp.vue?vue&type=style&index=0&id=703e9636&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703e9636",
  null
  
)

export default component.exports